var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tr", { staticClass: "grouprow-details" }, [
    _c(
      "td",
      { staticClass: "well-light", attrs: { colspan: "10" } },
      [
        _vm.concordances.results
          ? [
              _c("div", { staticClass: "concordance-controls clearfix" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary open-concordances",
                    attrs: { type: "button", disabled: _vm.disabled },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("openFullConcordances")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "fa fa-angle-double-left" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("results.table.viewDetailedConcordances"))
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.concordances.done
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-default",
                        attrs: {
                          type: "button",
                          disabled: _vm.concordances.loading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.concordances.next()
                          },
                        },
                      },
                      [
                        _vm.concordances.loading
                          ? [
                              _c("Spinner", { attrs: { inline: true } }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("results.table.loading")) +
                                  " HOI"
                              ),
                            ]
                          : [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("results.table.loadMoreConcordances")
                                )
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close close-concordances",
                    attrs: {
                      type: "button",
                      title: _vm.$t("results.table.close").toString(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_c("span", [_vm._v("×")])]
                ),
              ]),
              _vm._v(" "),
              _c("GenericTable", {
                staticStyle: { margin: "8px 0" },
                attrs: {
                  rows: _vm.concordances.results,
                  header:
                    _vm.type === "hits"
                      ? _vm.cols.hitColumns
                      : _vm.cols.docColumns,
                  cols: _vm.cols,
                  info: { ..._vm.info, detailedAnnotations: [] },
                  type: _vm.type,
                },
              }),
              _vm._v(" "),
              _vm.concordances.results?.rows.length > 10
                ? _c("div", { staticClass: "concordance-controls clearfix" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-primary open-concordances",
                        attrs: { type: "button", disabled: _vm.disabled },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("openFullConcordances")
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "fa fa-angle-double-left" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("results.table.viewDetailedConcordances")
                            )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.concordances.done
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-default",
                            attrs: {
                              type: "button",
                              disabled: _vm.concordances.loading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.concordances.next()
                              },
                            },
                          },
                          [
                            _vm.concordances.loading
                              ? [
                                  _c("Spinner", { attrs: { inline: "" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("results.table.loading")) +
                                      " HOI"
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "results.table.loadMoreConcordances"
                                      )
                                    )
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.concordances.error != null
          ? _c("div", {
              staticClass: "text-danger",
              domProps: { innerHTML: _vm._s(_vm.concordances.error) },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.concordances.results && _vm.concordances.loading
          ? _c("Spinner", { attrs: { center: "" } })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }